export default {
    routerName: '菜单编辑',
    menu: {
        frontEndName: '前端展示',
        backEndName: '后端管理',
        parentName: '父节点名',
        menuName: '菜单名',
        buttonName: '按钮名',
        icon: '图标',
        url: 'URL',
        permit: '权限',
        sortOrder: '排序',
        type: '类型',
        catalog: '目录',
        typeMenu: '菜单',
        typeButton: '按钮',
        status: '状态',
        statusOpen: '启用',
        statusClose: '停用',
        selected: '选择',
    },
};
